import * as React from "react";
import styled from "styled-components";

import { Card, Text } from "../../../../components/atoms";
import { theme } from "../../../../theme";
import { dateFromIso } from "../../../../utils/index";

const DateTimePreloaderMonth = styled(Text)`
  margin-bottom: 7px;
`;

const DateTimePreloaderCard = styled(Card)`
  width: 100%;
  height: 52px;
  border: 1px solid transparent;
  background: repeating-linear-gradient(
    to right,
    white,
    white 86px,
    ${theme.color.ruubyGreyBg} 86px,
    ${theme.color.ruubyGreyBg} 96px
  );
  box-shadow: none;

  @media screen and (max-width: 992px) {
    background: repeating-linear-gradient(
      to right,
      white,
      white 56px,
      ${theme.color.ruubyGreyBg} 56px,
      ${theme.color.ruubyGreyBg} 66px
    );
  }
`;

const DateTimePreloaderWrapper = styled.div`
  padding-top: 4px;
  margin: 0 5% 84px;
`;

const DateTimePreloader: React.FC = () => {
  return (
    <DateTimePreloaderWrapper>
      <DateTimePreloaderMonth size="12">
        {dateFromIso("now").toFormat("LLLL")}
      </DateTimePreloaderMonth>
      <DateTimePreloaderCard />
    </DateTimePreloaderWrapper>
  );
};

export { DateTimePreloader };
